import mixpanel from "mixpanel-browser"

const projectId =
  import.meta.env.VITE_APP_STAGE === "production"
    ? "07c53da4d0f6d07267b38838ff6e3298"
    : "de9aed8d7649fbe02dec43d91e9956cd"

mixpanel.init(projectId, {
  debug: import.meta.env.VITE_APP_STAGE !== "production",
  track_pageview: true,
  persistence: "localStorage",
  ignore_dnt: true,
})
